import React, {useEffect, useState} from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import {useSelector} from "react-redux";
import axios from "axios";
import {toast} from "react-toastify";
import {isEmpty} from "../../../../_helpers/commonFunctions";
import {Col, Row, Spinner} from "react-bootstrap";
import DateHelper from "../../../primer/DateHelper/DateHelper";
import DateBox from "../../../primer/DateBox";
import moment from "moment";
import Dropdown from "../../../primer/Dropdown";
import Alert from "react-bootstrap/Alert";

const BankTransactionsModal = ({show, setShow, selectedBank}) => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const [loading, setLoading] = useState(false);
    const defaultRequestData = {
        date_from: moment(company.year, "YYYY").startOf("year").format("DD/MM/YYYY"),
        date_to: moment(company.year, "YYYY").endOf("year").format("DD/MM/YYYY"),
    }
    const [requestData, setRequestData] = useState({...defaultRequestData});
    const [responseText, setResponseText] = useState("");

    useEffect(() => {
        if (!show) {
            setResponseText("");
        } else {
            setRequestData({...requestData, accountId: selectedBank.value});
        }
    }, [show])

    const handleFetch = () => {
        setResponseText("");
        if (isEmpty(requestData.accountId) || isEmpty(requestData.date_from) || isEmpty(requestData.date_to)) {
            return toast.warning("Παρακαλώ συμπληρώστε όλα τα πεδία.");
        }
        if (moment(requestData.date_to, "DD/MM/YYYY").hour(11) < moment(requestData.date_from, "DD/MM/YYYY").hour(10)) {
            return toast.error("Παρακαλώ επιλέξτε σωστά ημερομηνία από και έως.");
        }
        const cloneReqData = {...requestData};
        if (moment() < moment(requestData.date_to, "DD/MM/YYYY")) cloneReqData.date_to = moment().format("DD/MM/YYYY");

        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/accounting/force-fetch-transactions`, {
            company: company.id,
            year: company.year,
            ...cloneReqData,
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Επιτυχής άντληση συναλλαγών.");
                setResponseText(`Επιτυχής άντληση συναλλαγών λογαριασμού με IBAN: ${selectedBank.iban} για τη χρονική πεδίοδο ${res.data.date_from} - ${res.data.date_to}.
                <br/><strong>Σύνολο ήδη υπάρχων:</strong> ${res.data.totalUpdated}<br/><strong>Σύνολο νέων καταχωρήσεων:</strong> ${res.data.totalInserted}`);
            } else {
                toast.error(res.data.message);
            }
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    return (
        <React.Fragment>
            <Modal show={show} backdrop={"static"} onHide={() => setShow(false)} dialogClassName={"modal65PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Άντληση συναλλαγών</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={12}>
                            <Alert variant={"secondary"}>
                                <strong>Προσοχή!</strong> Οι περισσότερες τράπεζες επιτρέπουν μόνο 4 αντλήσεις συναλλαγών ανά 24ωρο.
                                Επίσης σημειώστε ότι κάθε 3η μέρα του μήνα γίνεται αυτόματη άντληση των συναλλαγών του προηγούμενου μηνός από το κεντρικό σύστημα.
                            </Alert>
                        </Col>
                    </Row>
                    <Row className={"mt-2"}>
                        <Col md={3}>
                            <Dropdown
                                name={"accountId"}
                                label={"Τραπεζικός Λογαριασμός"}
                                options={[selectedBank]}
                                defaultValue={[selectedBank]}
                                required={true}
                                disabled={true}
                                //onChange={(e) => setRequestData({...requestData, accountId: e.value})}
                            />
                        </Col>
                        <Col md={3}>
                            <DateHelper
                                dateFromAndToFunction={(from, to) => setRequestData({...requestData, date_from: from, date_to: to})}
                            />
                        </Col>
                        <Col md={3}>
                            <DateBox
                                name="date_from"
                                selected={moment(requestData.date_from, "DD/MM/YYYY").isValid() ? moment(requestData.date_from, "DD/MM/YYYY").toDate() : ""}
                                label={"Ημερομηνία από"}
                                required={true}
                                allowOtherYears={true}
                                onChange={(e) => {
                                    if (moment(e).isValid()) {
                                        setRequestData({...requestData, date_from: moment(e).format("DD/MM/YYYY")});
                                    } else {
                                        setRequestData({...requestData, date_from: ""});
                                    }
                                }}
                            />
                        </Col>
                        <Col md={3}>
                            <DateBox
                                name="date_to"
                                selected={moment(requestData.date_to, "DD/MM/YYYY").isValid() ? moment(requestData.date_to, "DD/MM/YYYY").toDate() : ""}
                                label={"Ημερομηνία έως"}
                                required={true}
                                allowOtherYears={true}
                                onChange={(e) => {
                                    if (moment(e).isValid()) {
                                        setRequestData({...requestData, date_to: moment(e).format("DD/MM/YYYY")});
                                    } else {
                                        setRequestData({...requestData, date_to: ""});
                                    }
                                }}
                            />
                        </Col>
                    </Row>
                    {responseText && (
                        <Row className={"mt-2"}>
                            <Col md={12}>
                                <Alert variant={"secondary"}>
                                    <div dangerouslySetInnerHTML={{__html: responseText}}></div>
                                </Alert>
                            </Col>
                        </Row>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShow(false)} disabled={loading}>
                        Κλείσιμο
                    </Button>
                    <Button variant="primary" onClick={() => handleFetch()} disabled={loading}>
                        Άντληση Συναλλαγών {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default BankTransactionsModal
